export const SUBSCRIPTION_REQUEST_DATA = 'SUBSCRIPTION/REQUEST_DATA';
export const SUBSCRIPTION_BEGIN_WRITE_DATA = 'SUBSCRIPTION/WRITE_DATA';
export const SUBSCRIPTION_COMPLETE_WRITE_DATA = 'SUBSCRIPTION/COMPLETE_WRITE_DATA';
export const RECEIVE_SUBSCRIPTIONS = 'SUBSCRPTION/RECEIVE_SUBSCRIPTIONS';
export const SET_ACTIVE_WORKSPACE_SUBSCRIPTION = 'SUBSCRIPTION/SET_ACTIVE_WORKSPACE_SUBSCRIPTION';
